<template>
  <div class="roseApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="cont">
      <div class="card">
        <ul>
          <h2>区域代理认证</h2>
          <li>
            <div class="bzj">区域保证金：<i>￥</i><b>{{setDetail.price}}</b></div>
            <p>
              <span><font color="red">*</font>姓名</span>
              <input type="text" v-if="setDetail.user_id <= 0" v-model="name" placeholder="请输入姓名" />
              <input type="text" v-if="setDetail.user_id > 0" readonly="readonly" v-model="name" placeholder="请输入姓名" />
            </p>
            <p>
              <span><font color="red">*</font>手机号</span>
              <input type="number" v-if="setDetail.user_id <= 0" v-model="phone" placeholder="请输入手机号" />
              <input type="text" v-if="setDetail.user_id > 0" readonly="readonly" v-model="phone" placeholder="请输入手机号" />
            </p>
            <p>
              <span><font color="red">*</font>身份证号</span>
              <input type="text" v-if="setDetail.user_id <= 0" v-model="idCard" placeholder="请输入身份证号" />
              <input type="text" v-if="setDetail.user_id > 0" readonly="readonly" v-model="idCard" placeholder="请输入身份证号" />
            </p>
          </li>
        </ul>
      </div>
      <ul class="scenic">
        <h1><font color="red">*</font>代理景点<span>分销商又销售，您就有收益</span></h1>
        <li v-for="(item,i) in setDetail.scenic" @click="toPush(item.id,'tkdetail')">
          <div class="title">
            <img :src="baseUrl+item.img" >
            <div class="conTitle">
              <span>{{item.title}}</span>
              <div class="price">门票<i><b>¥</b>{{item.rate.split(".")[0]}}.<b>{{item.rate.split(".")[1]}}</b></i>起
              <font>营业时间：{{item.business}}</font></div>
            </div>
          </div>
          <h2>热销门票<font>{{item.level}}级景区</font><font>限时折扣</font><font>优惠门票3折起</font></h2>
          <div class="ticket" v-for="(vo,k) in item.cards">
            <span><i class="el-icon-postcard"></i>{{vo.split("*")[0]}}</span>
            <p>￥{{vo.split("*")[1]}}<i class="el-icon-arrow-right"></i></p>
          </div>
        </li>
      </ul>
      <img class="success" v-if="setDetail.user_id > 0" src="~assets/images/crowd.png">
    </div>
    
    <div style="height:55px"></div>
    <div class="footer1" v-if="setDetail.user_id <= 0">
      <div class="foot-title">
        <span>合计：<i>￥</i><b>{{setDetail.price}}</b>
        </span>
      </div>
      <div class="pay" @click="payment">
        <span>立即开通</span>        
      </div>
    </div>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setDetail: [],
        name:'',
        phone:'',
        idCard:'',
      };
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
      
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getretail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getretail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/ticket/retailRose',
          params:{
            id:id,
          }
        }).then(function(response){
          var res = response.data.data;
          that.setDetail = res;
          if(res.user_id > 0){
            that.name = res.name;
            that.phone = res.phone;
            that.idCard = res.idcard;
          }
          
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      payment:function(){
        var that = this;
        if(that.name == ''){
          that.$alert('请输入姓名！!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.phone == ''){
          that.$alert('请输入手机号！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.idCard == ''){
          that.$alert('请输入身份证号！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        var id = this.$route.query.id;
        that.axios({
          method:'post',
          url:that.$host+'home/ticket/payOrder',
          params:{
            id:id,
            user_id:that.userData.id,
            phone:that.phone,
            name:that.name,
            idCard:that.idCard,
            price:that.setDetail.price,
            pid:1
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.callpay(res);
          }else{
            that.$alert('请核实信息后重新支付', '提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      jsApiCall:function(msg){
        var that = this;
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            "appId":'wxa89a20966e69c2a5',
            "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
            "nonceStr":msg.nonceStr, //随机串     
            "package":msg.package,     
            "signType":msg.signType,         //微信签名方式：     
            "paySign":msg.paySign 
          },
          function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok"){
                that.$alert('恭喜您，认证成功！', '提示', {
                  confirmButtonText: '确定',
                  success:function(){
                    that.getretail();
                  }
                });
              }else{
                 //返回跳转到订单详情页面
                  alert('支付失败');return false
              }
          }
        );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .roseApp{
    max-width:640px;
    margin:0 auto;
    position:relative;
    background:#ececec
  }
  .roseApp .cont{
    width:100%;
    display:block;
    margin:0 auto;
  }
  .roseApp .cont .success{
    position:absolute;
    right:0;
    top:20%;
    width:150px;
    z-index:999
  }
  .roseApp  ul{
    display:block;
    margin:0 auto;
    width:100%
  }
  .roseApp .scenic h1{
    width:92%;
    margin:0 auto;
    font-size:16px;
    padding:10px 0
  }
  .roseApp .scenic h1 span{
    font-size:13px;
    font-weight:normal;
    padding-left:10px;
    color:#666
  }
  .roseApp  ul li{
    display:block;
    width:100%;
    margin-bottom:1px;
    background:#fff;
    width:100%;
    padding:13px 0;
    background-size:20% !important
  }
  .roseApp  ul li .title{
    position:relative;
    width:100%;
  }
  .roseApp  ul li .title:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .roseApp  ul li .title img{
    float:left;
    width:20%;
    border-radius:6px;
    margin-left:3%
  }
  .roseApp  ul li .title .conTitle{
    float:left;
    width:73%;
    margin-left:2%;
  }
  .roseApp  ul li .title .conTitle span{
    display:block;
    color:#000;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size:15px;
    font-weight: 600;
  }
  .roseApp  ul li .title .conTitle font{
    color:#666;
    font-size:12px;
    padding-left:12px
  }

  .roseApp  ul li .title .conTitle .price{
    font-size: 12px;
    font-family: PingFang SC;
    color: #666;
    padding-top:15px
  }
  .roseApp  ul li .title .conTitle .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .roseApp  ul li .title .conTitle .price b{
    font-size:12px;
  }
  .roseApp  ul li .ticket{
    width:94%;
    margin:0 auto 1px auto;
    background:#f5f5f5;
    padding:10px 0;
    position:relative;
    border-radius:2px;
  }
  .roseApp  ul li .ticket span{
    display:inline-block;
    width:70%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size:14px;
    color:#333;
    margin-left:2%;
  }
  .roseApp  ul li .ticket span i{
    font-size:20px;
    float:left;
    color:#333;
    margin-right:5px
  }
  .roseApp  ul li .ticket p{
    position:absolute;
    right:2%;
    top:12px;
    color:#666;
    font-size:12px
  }
  .roseApp  ul li .ticket p i{
    font-size:15px;
    float:right;
    margin-top:1px
  }
  .roseApp  ul li h2{
    width:94%;
    margin:0 auto 1px auto;
    font-size:15px;
    padding:12px 0 5px 0
  }
  .roseApp  ul li h2 font{
    font-weight:normal;
    font-size:12px;
    padding-left:15px;
    color:#666
  }

  .roseApp .card{
    width:100%;
    display:block;
  }
  .roseApp .card h2{
    font-size:16px;
    position:relative;
    padding-bottom:10px;
    width:90%;
    margin:0 auto;
    padding-left:2%
  }
  .roseApp .card h2:after{
    content:'';
    width: 3px;
    height: 14px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:4px;
    border-radius: 3px;
  }

  .roseApp .card ul{
    width:100%;
    display:block;
    margin:0 auto;
    background:#fff;
    padding:15px 0 10px 0
  }
  .roseApp .card ul li{
    background:#f5f5f5;
    border-radius:6px;
    width:92%;
    margin:0 auto 10px auto;
    position:relative;
    padding-bottom:10px
  }
  .roseApp .card ul li p{
    height:50px;
  }
  .roseApp .card ul li p span{
    float:left;
    width:22%;
    height:50px;
    line-height:50px;
    margin-left:5%;
    font-size:15px;
    color:#666
  }
  .roseApp .card ul li p input{
    float:left;
    line-height:35px;
    font-size:14px;
    height:35px;
    border:none;
    width:67%;
    margin-top:8px;
    padding:0 5px;
    outline:none;
  }
  .roseApp .card ul li .bzj{
    margin-left:5%;
    padding:15px 0 10px 0;
    font-size:15px;
    font-weight:bold
  }
  .roseApp .card ul li .bzj i{
    font-size:12px;
    color:#f00
  }
  .roseApp .card ul li .bzj b{
    font-size:18px;
    color:#f00
  }

  .roseApp .footer1{
    height: 50px;
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0;
    z-index: 1
  }
  .roseApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:50px;
    line-height:50px;
  }
  .roseApp .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
  }
  .roseApp .footer1 .foot-title span:first-child{
    margin-right:8px
  }
  .roseApp .footer1 .foot-title span b{
    color: #f00;
    font-size:17px;
    font-weight:500;
  }

  .roseApp .footer1 .foot-title span i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }

  .roseApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:40%
  }
  .roseApp .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #FF751A;
    border-radius:40px;
  }

</style>